import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { Catalog, Product } from "../../models/product.model";
import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import { DialogProductComponent } from "../dialog-product/dialog-product.component";
import Shop from "../../models/shop.model";
import { DialogPrintProductsComponent } from "../dialog-print-products/dialog-print-products.component";

@Component({
  selector: "ngx-view-table-crud-products",
  styleUrls: ["./view-table-crud-products.component.scss"],
  templateUrl: "./view-table-crud-products.component.html",
})
export class ViewTableCrudProductsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = "units"; //product.mode
  @Input() products?: Product[] = [];
  @Output() onSelectedProduct: EventEmitter<any> = new EventEmitter();

  @Input() shop?: Shop;
  @Input() units?: Catalog[] = [];
  @Input() groups?: Catalog[] = [];
  @Input() categories?: Catalog[] = [];
  @Input() suppliers?: Catalog[] = [];
  @Input() producers?: Catalog[] = [];
  @Input() origins?: Catalog[] = [];
  @Input() sizes?: Catalog[] = [];
  @Input() colors?: Catalog[] = [];

  @ViewChild("title") title: ElementRef;
  @ViewChild("price") price: ElementRef;

  product: Product = new Product();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";
  user: User;

  //ng2-smart-table config
  @Input() source: LocalDataSource = new LocalDataSource();
  settings = {
    hideHeader: false,
    noDataMessage: "Không có dữ liệu",
    pager: {
      display: true,
      perPage: 10,
    },
    actions: {
      columnTitle: "",
      add: false,
      edit: false,
    },
    add: {
      confirmCreate: true,
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      confirmSave: true,
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      confirmDelete: true,
      deleteButtonContent: '<i class="nb-trash"></i>',
    },

    columns: {
      barcode: {
        title: "Mã sản phẩm",
        type: "string",
      },
      title: {
        title: "Tên sản phẩm",
        type: "string",
      },
      unitName: {
        title: "ĐVT",
        width: "100px",
        filter: false,
        type: "string",
      },
      price: {
        title: "Giá bán",
        width: "100px",
        filter: false,
        type: "custom",
        renderComponent: StbCustomRenderNumberComponent,
      },
    },
  };

  constructor(
    private userService: UserService,
    private productService: ProductService,
    private router: Router,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      //
    }, 1000);
  }

  //Quick create product
  initNewProduct() {
    let newProd = new Product();
    newProd.shopId = this.shopId;
    newProd.title = "";
    newProd.unitId = this.product.unitId;
    newProd.unitName = this.product.unitName;
    newProd.groupId = this.product.groupId;
    newProd.groupName = this.product.groupName;
    newProd.categoryId = this.product.categoryId;
    newProd.categoryName = this.product.categoryName;
    newProd.isStock = true;
    this.product = newProd;
  }

  printProducts() {
    this.dialogService
      .open(DialogPrintProductsComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          products: this.products,
          shop: this.shop,
          showSelection: true,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }

  onNew() {
    this.initNewProduct();

    this.dialogService
      .open(DialogProductComponent, {
        context: {
          header: "Tạo mặt hàng",
          user: this.user,
          mode: "new",
          product: this.product,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
          products: this.products,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.initNewProduct();
        }
      });
  }

  //smart-table events
  onCreateConfirm(event): void {
    console.log("onCreateConfirm:", event);
    const title = event.newData.title;
    const price = event.newData.price;
    const unitName = event.newData.unitName;
    if (title.length > 0 && price > 0) {
      let prod = new Product();
      prod.title = title;
      prod.price = price;
      prod.unitName = unitName;
      prod.shopId = this.shopId;

      this.loading = true;
      this.submitted = true;

      this.productService
        .create(prod)
        .then((data) => {
          event.newData["id"] = data.id;
          event.newData["title"] = title;
          event.newData["price"] = price;
          event.newData["unitName"] = unitName;
          event.confirm.resolve(event.newData);

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          event.confirm.reject();
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  onSaveConfirm(event) {
    const id = event.data.id;
    const title = event.newData.title;
    const price = event.newData.price;
    const costPrice = event.newData.costPrice;
    const unitName = event.newData.unitName;
    if (title.length > 0 && price > 0) {
      this.loading = true;
      this.submitted = true;

      this.productService
        .updatePrice(this.shopId, id, title, unitName, price, costPrice)
        .then((data) => {
          event.newData["title"] = title;
          event.newData["price"] = price;
          event.confirm.resolve(event.newData);

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          event.confirm.reject();
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  onDeleteConfirm(event): void {
    console.log("onDeleteConfirm:", event);
    const id = event.data.id;
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.productService
            .delete(this.shopId, id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              event.confirm.resolve();

              //sync data to offline DB
              let item = event.data;
              item.isDeleted = true;
              this.productService.sync(item);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
              event.confirm.reject();
            });
        } else {
          event.confirm.reject();
        }
      });
  }

  selectedProduct(event): void {
    // console.log("selectedProduct:", event);
    let item = event.data;

    if (event.selected) {
      event.isSelected = false;
    }

    let lecBk = new Product();
    lecBk = _.clone(item);
    this.dialogService
      .open(DialogProductComponent, {
        context: {
          header: "Cập nhật sản phẩm",
          user: this.user,
          mode: "edit",
          product: lecBk,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        console.log("DialogProductComponent/edit:", value);
        if (value) {
          item = value;
          this.product = value;
        }
      });
  }
}
